import { render, staticRenderFns } from "./Matrix4View.vue?vue&type=template&id=25615c50&scoped=true"
import script from "./Matrix4View.vue?vue&type=script&lang=js"
export * from "./Matrix4View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25615c50",
  null
  
)

export default component.exports